// frontend/src/components/CRSFormSections/SpouseFactorsSection.js
import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography
} from '@mui/material';
import {
  BAD_VALUE,
  educationLevelOptions,
  canadianWorkExperienceOptions,
  languageTestOptions,
  languageScoreOptions
} from '../../constants/crsFormOptions'; // Adjust path as needed

function SpouseFactorsSection({
  formData,
  handleChange,
  handleLanguageScoreChange,
  handleFocus,
  showSpouseLanguageScores
}) {
  return (
    <> {/* Use Fragment as this section might not always render */}
      <Typography variant="h6" sx={{ mt: 2 }}>Spouse/Partner Factors</Typography>

      {/* Spouse Education */}
      <FormControl fullWidth required>
        <InputLabel id="spouse-education-label">11. What is your spouse/partner's level of education?</InputLabel>
        <Select
          labelId="spouse-education-label"
          name="spouseEducationLevel"
          value={formData.spouseEducationLevel}
          label="11. What is your spouse/partner's level of education?"
          onChange={handleChange}
          onFocus={() => handleFocus('spouseEducationLevel')}
        >
          {educationLevelOptions.map(option => ( // Use same options as main applicant
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Spouse Canadian Work Experience */}
      <FormControl fullWidth required>
        <InputLabel id="spouse-canadian-work-label">12. In the last ten years, how many years of Canadian work experience does your spouse/partner have?</InputLabel>
        <Select
          labelId="spouse-canadian-work-label"
          name="spouseCanadianWorkExperience"
          value={formData.spouseCanadianWorkExperience}
          label="12. In the last ten years, how many years of Canadian work experience does your spouse/partner have?"
          onChange={handleChange}
          onFocus={() => handleFocus('spouseCanadianWorkExperience')}
        >
          {canadianWorkExperienceOptions.map(option => ( // Use same options as main applicant
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Spouse Language Test */}
      <FormControl fullWidth required>
        <InputLabel id="spouse-test-type-label">13. Did your spouse/partner take a language test? If so, which one?</InputLabel>
        <Select
          labelId="spouse-test-type-label"
          name="spouseLanguageTest"
          value={formData.spouseLanguageTest}
          label="13. Did your spouse/partner take a language test? If so, which one?"
          onChange={handleChange}
          onFocus={() => handleFocus('spouseLanguageTest')}
        >
          {languageTestOptions.map(option => ( // Use same options as main applicant
            <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
              {option.label}
            </MenuItem>
          ))}
          {/* Add Not Applicable option if needed based on original script */}
           <MenuItem value={"E"}>Not applicable</MenuItem>
        </Select>
      </FormControl>

      {/* Spouse Language Scores (Conditional) */}
      {showSpouseLanguageScores && (
         <Box sx={{ border: '1px solid lightgray', p: 2, borderRadius: 1 }}>
            <Typography variant="subtitle1" gutterBottom>Enter Spouse/Partner Scores for {languageTestOptions.find(t => t.value === formData.spouseLanguageTest)?.label}:</Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', sm: '1fr 1fr 1fr 1fr' }, gap: 2 }}>
                {['speaking', 'listening', 'reading', 'writing'].map((skill) => (
                  <FormControl fullWidth key={skill} required>
                    <InputLabel id={`spls-${skill}-label`}>{skill.charAt(0).toUpperCase() + skill.slice(1)}</InputLabel>
                    <Select
                      labelId={`spls-${skill}-label`}
                      name={skill}
                      value={formData.spouseLanguageScores[skill]}
                      label={skill.charAt(0).toUpperCase() + skill.slice(1)}
                      onChange={(e) => handleLanguageScoreChange('spouseLanguageScores', skill, e.target.value)}
                      onFocus={() => handleFocus(`spouseLanguageScores.${skill}`)}
                    >
                      {(languageScoreOptions[formData.spouseLanguageTest]?.[skill] || []).map(option => (
                        <MenuItem key={option.value} value={option.value} disabled={option.value === BAD_VALUE}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ))}
              </Box>
          </Box>
      )}
    </>
  );
}

export default SpouseFactorsSection;